export default __webpack_public_path__ + "static/media/thumb_up.3d6b3317.svg";